module.exports = __webpack_public_path__ + "img/126.c3b4dbe.svg";